import type {Prize} from 'api/types';

export const isPrizeValue = (value: unknown): value is Prize =>
  typeof value === 'object' && (value as Prize).winners != null;
